<template>
  <div class="page-container">
    <div class="main">
      <page :url="url" :form="form">
        <template slot="tableSearch" v-if="ROLE_TYPE.isManager()">
          <el-form-item :label="$t('text.agentNumber')">
            <el-select v-model="form.agentId" :placeholder="$t('text.agentNumber')" maxlength="50" filterable>
              <el-option v-for="item in agentList"
                         :key="item.agentName"
                         :label="item.agentId + ' - ' + item.agentName"
                         :value="item.agentId"/>
            </el-select>
          </el-form-item>
        </template>
        <template slot="buttonArea" v-if="ROLE_TYPE.isManager()">
          <el-button type="primary" @click="addAgent" size="small">
            {{ $t('text.addAgent') }}
          </el-button>
        </template>

        <template slot="tableColumn">
          <el-table-column prop="agentId" :label="$t('text.agentNumber')" align="left"/>
          <el-table-column prop="agentName" :label="$t('text.agentName')" align="left"/>
          <el-table-column prop="loginName" :label="$t('text.loginName')" align="left"/>

          <!-- Payment Rate Columns -->
          <template v-for="(value, key) in PaymentType[this.country].PAYMENT">
            <el-table-column
                prop="paymentRateConfig"
                :label="$t(`text.collection${key}FeeRateLineBreak`)"
                :render-header="renderheader"
                align="left"
                width="120px"
            >
              <template slot-scope="scope">
                {{ JSON.parse(scope.row.paymentRateConfig || '{}')[value] || '' }}
              </template>
            </el-table-column>
          </template>

          <!-- Transfer Rate Columns -->
          <template v-for="(value, key) in PaymentType[this.country].TRANSFER">
            <el-table-column
                prop="transferRateConfig"
                :label="$t(`text.disbursement${key}FeeRateLineBreak`)"
                :render-header="renderheader"
                align="left"
                width="120px"
            >
              <template slot-scope="scope">
                {{ JSON.parse(scope.row.transferRateConfig || '{}')[value] || '' }}
              </template>
            </el-table-column>
          </template>

          <el-table-column fixed="right" :label="$t('text.actions')" width="80" align="center" v-if="ROLE_TYPE.isManager()">
            <template slot-scope="scope">
              <el-button type="primary" plain size="mini" @click="editAgent(scope.row)">
                {{ $t('text.edit') }}
              </el-button>
            </template>
          </el-table-column>
        </template>
      </page>

      <AgentEdit :show.sync="showDialog" :formData="formData" :action="action"></AgentEdit>

    </div>
  </div>
</template>

<script>
import Page from '@/components/Page.vue'
import AgentEdit from './AgentEdit'
import {ROLE_TYPE} from "@/utils/Constant";
// import AgentCreate from "@/views/agent/AgentCreate.vue";
import { PaymentType } from '@/constants/paymentTypes';

export default {
  name: "Systems",
  computed: {
    ROLE_TYPE() {
      return ROLE_TYPE
    }
  },
  components: {
    'page': Page,
    AgentEdit: AgentEdit,
    // AgentCreate: AgentCreate
  },
  data() {
    return {
      country: this.$store.state.isPK ? 'PK' : 'BD',
      url: '/agent/selectList',
      action: '',
      form: {
        agentId: ''
      },
      agentList: [],
      showDialog: false,
      showCreateDialog: false,
      formData: null,
      PaymentType
    }
  },
  created() {
    this.$axios.get('/agent/selectAgentForOption', {params: {}})
        .then(res => {
          this.agentList = res.data
        })
  },
  methods: {
    addAgent() {
      this.action = "addAgent";
      this.formData = null;
      this.showDialog = true;
    },
    editAgent(row) {
      this.action = "editAgent";
      this.formData = row;
      this.showDialog = true;
    },
    renderheader(h, {column, $index}) {
      return h("span", {}, [
        h("span", {}, column.label.split("/")[0]),
        h("br"),
        h("span", {}, column.label.split("/")[1])
      ]);
    },
  }
}
</script>

<style scoped>

</style>